import type { ReactNode } from "react";

/**
 * The top of every page: the title (the page's one h1), a muted line under
 * it, and the page's own actions on the right. Wraps on narrow screens: the
 * actions drop under the title.
 *
 * From `lg` the top bar already shows the screen's name big (GMS's rule, as
 * in OVR: no second big title in the page), so the h1 stays for screen
 * readers only and the subtitle leads.
 */
export function PageHeader({
	title,
	subtitle,
	actions,
	className = "",
}: {
	title: ReactNode;
	subtitle?: ReactNode;
	actions?: ReactNode;
	className?: string;
}) {
	return (
		<header className={`mb-[1rem] flex flex-wrap items-end justify-between gap-x-[1rem] gap-y-[0.75rem] ${className}`}>
			<div className="flex min-w-0 flex-col gap-[0.25rem]">
				<h1 className="font-black text-[1.5rem] text-ink leading-tight [overflow-wrap:anywhere] lg:sr-only">{title}</h1>
				{subtitle && <div className="max-w-[70ch] text-[0.875rem] text-muted leading-normal">{subtitle}</div>}
			</div>
			{actions && <div className="flex flex-wrap items-center gap-[0.5rem]">{actions}</div>}
		</header>
	);
}
